import React from 'react';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import Footer from '../components/Footer';
import Header from '../components/Header';
import SEO from '../components/SEO';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Learnaicare',
  url: 'https://lrnaicare.net/',
  description:
    'Manage subscriptions, request cancellations, review billing charges, and contact support agents for fast assistance and account help.',
  publisher: {
    '@type': 'Organization',
    name: 'Learnaicare',
    logo: {
      '@type': 'ImageObject',
      url: 'https://lrnaicare.net/logo192.png',
    },
  },
};

export default function HomePage() {
  return (
    <div className="page-shell min-h-screen">
      <SEO
        title="Subscription Support & Cancellation Help | Learnaicare"
        description="Manage subscriptions, request cancellations, review billing charges, and contact support agents for fast assistance and account help."
        canonical="https://lrnaicare.net/"
        ogUrl="https://lrnaicare.net/"
        schema={homeSchema}
      />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Features />
      </main>
      <Footer />
    </div>
  );
}
